<div class="flex flex-col gap-4 text-gray-700 text-sm" *vsLet="status$ | async as status">
  <p>
    Connect Budco Financial Services (BFS) so authorized checkout users can offer financing. Dealer ID and product
    mappings are tenant-scoped and required before financing can be enabled.
  </p>

  <div *ngIf="status && !status.credentialsConfigured" class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
    Valid Budco Financial Services (BFS) credentials have not been configured for this tenant. Configure them before
    enabling financing.
  </div>

  <div
    *ngIf="status?.credentialsConfigured && !status?.configured"
    class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
  >
    Budco Financial Services (BFS) credentials are configured, but checkout setup is incomplete. Add a Budco dealer ID
    and product-prefix mappings before enabling financing.
  </div>

  <div *ngIf="blockedReason" class="rounded-lg border border-danger-200 bg-danger-50 px-3 py-2 text-danger-800">
    {{ blockedReason }}
  </div>

  <form [formGroup]="form" class="flex flex-col gap-4">
    <label class="flex flex-col gap-1">
      <span class="text-gray-700 font-medium text-sm">Environment</span>
      <vs-select vsInput formControlName="environment" placeholder="Select environment">
        <li *ngFor="let option of environmentOptions" vs-select-option [value]="option.value">{{ option.label }}</li>
      </vs-select>
      <span class="text-xs text-gray-500"
        >Per-tenant Budco Financial Services (BFS) host override (training / staging / production). When unset, uses the
        app/mode default from secrets.</span
      >
      <button
        *ngIf="status?.environmentOverridden"
        vs-button
        type="button"
        appearance="outline"
        class="mt-1 self-start"
        [disabled]="saving"
        (click)="useDefaultEnvironment()"
      >
        Use app default
      </button>
    </label>

    <label class="flex flex-col gap-1">
      <span class="text-gray-700 font-medium text-sm">Budco Financial Services (BFS) dealer ID</span>
      <input vsInput type="text" placeholder="Dealership ID" formControlName="dealershipId" />
    </label>

    <label class="flex flex-col gap-1">
      <span class="text-gray-700 font-medium text-sm"
        >Budco Financial Services (BFS) dealer product IDs by policy prefix</span
      >
      <textarea
        vsInput
        rows="5"
        placeholder="budco_product_id1: PREFIX*, *PREFIX*&#10;budco_product_id2: *"
        formControlName="productMappings"
      ></textarea>
      <span class="text-xs text-gray-500"
        >Use one line per product mapping in this format: product_id: PREFIX1, PREFIX2. Prefix matching is
        case-insensitive.
        <br />
        Use * wildcards: * (all), PREFIX* (starts with), *PREFIX (ends with), *PREFIX* (contains).</span
      >
    </label>
  </form>

  <div class="flex flex-wrap justify-end gap-2" *ngIf="canManageBfs$ | async">
    <button
      *ngIf="status?.dealershipConfigured || status?.productMappingsConfigured"
      vs-button
      type="button"
      appearance="outline"
      theme="danger"
      [disabled]="saving"
      (click)="removeDialog.open()"
    >
      Remove settings
    </button>
    <button *ngIf="status?.enabled" vs-button type="button" [disabled]="saving" (click)="disableDialog.open()">
      Disable
    </button>
    <button
      *ngIf="status?.enabled"
      vs-button
      type="button"
      theme="primary"
      [disabled]="saving || form.invalid || !form.dirty"
      (click)="update()"
    >
      {{ saving ? 'Saving...' : 'Save changes' }}
    </button>
    <button
      *ngIf="!status?.enabled"
      vs-button
      type="button"
      theme="primary"
      [disabled]="saving || form.invalid || !status?.credentialsConfigured || !!blockedReason"
      (click)="enable()"
    >
      {{ saving ? 'Saving...' : 'Enable' }}
    </button>
  </div>
</div>

<vs-dialog #disableDialog [config]="{dialogContainerClass: 'w-full md:w-96'}">
  <vs-dialog-header
    [config]="{icon: 'bank-note-01', iconTheme:'primary', title: 'Disable Budco Financial Services (BFS) financing?' , subtitle: 'New checkout applications will be blocked. Existing application references and statuses are kept.', mode: 'simple', hideCloseButton: true}"
  ></vs-dialog-header>
  <div class="w-full flex flex-row gap-2 justify-between">
    <button vs-button class="w-1/2" appearance="outline" (click)="disableDialog.close()">Cancel</button>
    <button vs-button class="w-1/2" theme="danger" (click)="disable(); disableDialog.close()">Disable</button>
  </div>
</vs-dialog>

<vs-dialog #removeDialog [config]="{dialogContainerClass: 'w-full md:w-96'}">
  <vs-dialog-header
    [config]="{icon: 'bank-note-01', iconTheme:'primary', title: 'Remove Budco Financial Services (BFS) settings?' , subtitle: 'Dealer ID and product mappings are cleared for this tenant and Budco Financial Services (BFS) is disabled. Existing application references are kept.', mode: 'simple', hideCloseButton: true}"
  ></vs-dialog-header>
  <div class="w-full flex flex-row gap-2 justify-between">
    <button vs-button class="w-1/2" appearance="outline" (click)="removeDialog.close()">Cancel</button>
    <button vs-button class="w-1/2" theme="danger" (click)="remove(); removeDialog.close()">Remove settings</button>
  </div>
</vs-dialog>
